export default __webpack_public_path__ + "static/media/productTwo.89b9fcd3.jpeg";